import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import React from 'react';
import { Button } from '@famly/mf_input_button';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { useAriaAndDataProps } from '@famly/mf_ts-utils_data-aria-props';
import { SplitModalContext } from './split-modal';
/**
 * ModalSecondaryButton component
 *
 * The secondary action button for modals, typically used for cancellation or alternative actions.
 * Renders as a secondary button with responsive sizing based on viewport width.
 *
 * - On mobile: Regular size
 * - On tablet and larger: Compact size
 *
 * Should be used inside ModalFooterButtons.
 *
 * @param {ModalSecondaryButtonProps} props - Component props
 * @param {ButtonProps['text']} [props.text='Confirm'] - Button text
 * @param {ButtonProps['isDisabled']} [props.isDisabled] - Button disabled flag
 * @param {ButtonProps['icon']} [props.icon] - Optional icon to display in the button
 * @param {Buttonprops['onClick']} [props.onClick] - Optional onClick for the button
 *
 * @example
 * <ModalFooterButtons>
 *   <ModalSecondaryButton text="Cancel" onClick={handleCancel} />
 *   <ModalPrimaryButton text="Save" onClick={handleSave} />
 * </ModalFooterButtons>
 */
export const ModalSecondaryButton = ({ text, icon, isDisabled, onClick, href, target, ...rest }) => {
    const { isTabletPortraitAndLarger } = useBreakpoints();
    const dataAriaProps = useAriaAndDataProps(rest);
    const context = React.use(SplitModalContext);
    return (_jsx(Button, { fullWidth: (context === null || context === void 0 ? void 0 : context.variant) !== 'fullModal', size: isTabletPortraitAndLarger || (context === null || context === void 0 ? void 0 : context.variant) === 'fullModal' ? 'compact' : 'regular', type: "button", variant: "tertiary", text: text !== null && text !== void 0 ? text : i18next.t($ => $.mf.modalsDialogs_modal.src.translations.json.closeButtonAriaLabel), icon: icon, isDisabled: isDisabled, onClick: onClick, order: isTabletPortraitAndLarger ? 2 : 3, href: href, target: target, ...dataAriaProps }));
};
